import React from "react";
import { useState } from "react";

function FileUploadDemo() {
  const [fileData, setFileData] = useState(null);
  const handleChange = (e) => {
    setFileData(e.target.files[0]);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("File data : ", fileData.file);
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input type="file" onChange={handleChange} />
        <button>Upload File</button>
      </form>
    </div>
  );
}

export default FileUploadDemo;
